/** @file The bones of the slots whose skin entries show a mesh (its candidate slot bones). */
import type { Doc, Id } from '@pose2d/format/types';

/** Bone ids of every slot that a skin entry maps attachment `id` into; empty when no skin uses it. */
export function meshSlotBones(doc: Doc, id: Id): Set<Id> {
  const bones = new Set<Id>();
  for (const skin of Object.values(doc.skins)) {
    for (const entry of skin.entries) {
      const bone = entry.attachment === id ? doc.slots[entry.slot]?.bone : undefined;
      if (bone !== undefined) bones.add(bone);
    }
  }
  return bones;
}
